// extracted by mini-css-extract-plugin
export default {"social":"Social_social__2scHd","socialIcon":"Social_socialIcon__aONnB","socialLink":"Social_socialLink__4rZut"};